import sdl from '@jds/react-generated-sdl/JDSVerticalStepItem';
import type { JDSVerticalStepItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSVerticalStepItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    state = 'undefined',
    direction = 'both',
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { state, direction, ariaLabel, ...rest },
    'JDSVerticalStepItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const VerticalStepItem = withLogic(
  Component
) as React.FC<JDSVerticalStepItemProps> & { slotName?: string };

VerticalStepItem.displayName = 'VerticalStepItem';
VerticalStepItem.slotName = 'jds_vertical_step_item';

export { VerticalStepItem, type JDSVerticalStepItemProps };
